var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutomateProcesses = function SvgAutomateProcesses(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 14,
    "data-width-20": 17,
    "data-width-24": 20,
    "data-width-28": 24,
    "data-width-36": 26,
    "data-width-72": 52,
    viewBox: "0 0 10 10",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M4.1.4v3.7H.4V.4zM2.25 5.9a1.85 1.85 0 1 1 0 3.7 1.85 1.85 0 0 1 0-3.7Zm7.35 0v3.7H5.9V5.9zM7.75.4a1.85 1.85 0 1 1 0 3.699A1.85 1.85 0 0 1 7.75.4Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutomateProcesses);
export default ForwardRef;